import { Fragment, h } from "preact";
import { memo } from "react";
import { compareRender } from "../../../functions/form";
import { useController, UseControllerProps } from "react-hook-form";
import { Button, Row, Upload } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import { Text } from "../../text";
import { StyledFileUpload } from "./styled";

interface IItem extends UseControllerProps {
  ref: string;
  id: string;
  format?: string;
  label?: string;
  placeholder?: string;
  accept?: string;
}

interface IFileUpload {
  control?: any;
  item: IItem;
  handleChange?: any;
}

const FileUpload = ({ control, item, handleChange }: IFileUpload) => {
  const { ref, rules, name, defaultValue, label, accept } = item;
  const { field, fieldState } = useController({
    control,
    name,
    rules,
    defaultValue,
  });
  const { error } = fieldState;
  const { value } = field;

  return (
    <>
      <Row>
        {label && <Text size={"XS"} text={label} bold={true} />}
        {error && <div />}
      </Row>
      <StyledFileUpload
        id={ref}
        name={ref}
        beforeUpload={() => false}
        accept={accept || "*"}
        onChange={(e) => handleChange(e, item)}
        fileList={value}
      >
        <Button
          style={{ width: "100%" }}
          icon={(<UploadOutlined />) as React.ReactNode}
        >
          Upload
        </Button>
      </StyledFileUpload>
    </>
  );
};

export const MemoizedFileUpload = memo(FileUpload, compareRender);
